import HtmlMapper from "react-html-map";

type HtmlRendererProps = {
  html: string;
};

export const HtmlRenderer = ({ html }: HtmlRendererProps) => {
  return (
    <HtmlMapper html={html} decodeEntities={true}>
      {{
        b: ({ children, ...rest }) => (
          <strong className="font-bold" {...rest}>
            {children}
          </strong>
        ),
        strong: ({ children, ...rest }) => (
          <strong className="font-bold" {...rest}>
            {children}
          </strong>
        ),
        em: ({ children, ...rest }) => (
          <em className="italic" {...rest}>
            {children}
          </em>
        ),
        i: ({ children, ...rest }) => (
          <i className="italic" {...rest}>
            {children}
          </i>
        ),
        p: ({ children, ...rest }) => {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const { style, ...restProps } = rest;
          return (
            <p className="mb-4 last:mb-0" {...restProps}>
              {children}
            </p>
          );
        },
        span: ({ children, ...rest }) => {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const { style, ...restProps } = rest;
          return <span {...restProps}>{children}</span>;
        },
      }}
    </HtmlMapper>
  );
};
